// Jurassic Park terminal easter egg.
// Keep the exact strings from the original v1.x site; these are printed
// to the browser console when the user interacts with the back button.

export const sysReady =
  'Dinosaur Park, System Security Interface\n' +
  'Version 4.0.5, Alpha E\n' +
  'Ready...\n';

export const newman = [
  '░░░░░░░░░░░░░░░░░░░░░░░░▒▒▒▒▒▓▓▓▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░░░░░▒▓██████████████████████▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░▒█████████████████████████████████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░▒███████████████████████████████████████▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░▒▓██████████████████████████████████████████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░▓██████████▓▓▓▓▓▒▓▓▓▓▓▓▓▓██████████████████████▓░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░▓████████▓▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓█████████░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░▒████████▓▓▒▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓███████░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░▒████████▓▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓██████▒░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░▒█▓████▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓████▒░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░▓█████▓▒░▒▒▒▒▒▒▒▓▓▓▓▓▓▓█████▓▓████████████▓▓▓▓▓██▒░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░▒▓▒▓▓▒░░░▒▒▒▒▒▒▓▓▓███████▓▓▓▓████████████▓▓▓▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░▒▒▒░░░░▒▒▒▒▓▓▓▓▓▓█████▓▓▓▒▓▓▓▓███████████▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░▒░░░░░░▒▒▒▒▒▓▓▓▓▓▓▓▓▓▒▒▒▒▓▓█▓████████████▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░░░▒▒▒▒▒▒▓▓▓████▓▓▒▒▓▒▓▓▓█████████████▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░░░▒▒▒▒▒▓▓████▓▒▒▒▓▓▓▓▓███████████████▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓███████████████▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░▒▒▒▒▒▒▒▒▓▓▓▒▒▒▒▒▒▒▒▓▓▓██████████████▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░▒▒▒▒▒▒▒▒▒▓▓▒▒▒▒▒▒▒▒▒▓▓▓▓█████▓██████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓█████████████░░░░░░░░░░░░░░░░░░░░░░░░▒▒░░░░',
  '░░░░░░░░░░░░░▒▒▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓██████████████▓░░░░░░░░░░░░░░░░░░░░░░▒▒▒▒░░░░',
  '░░░░░░░▒▓▓▓▓▓▓▓▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓███████████████▓▓▓▓▓▒▒▒▒░░░░░░░░░░░▒▒▒▒▒▒▓▒▒░░',
  '░░░░▒▓▓▓▓▒▒▒▒▒▒▓▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓██████████████▒▒▒▒▒▒▒▒▒▒▒▒▒▓▒░░░░░░░▒▒▒▒▓▓▒▒▒▒░░',
  '░░░▒▒▓▒▒▓▓▒▒▒▒▓▓▓▓▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒░░▒▒▒░░▒▒▒▒▒▒▒▒▒▒░░░░',
  '░░▒▒▒▒▒▒▓▓▓▒▒▒▒▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒░░░▒▒▒▒▒▒▒▒▒▒░▒▒▒▒▒▒▒▒░▒▒░░░░░░░░░',
  '░▓▒▒▒▒▓▓▒▒▓▒▒▒▒▓▒░▒▒▒░░░░▒▒▒▒▓▓▓▒▒▓▓▓▓▒▒▓▓▓▓▒▒▒▒▒░▒▒▒▒▓▓▒▒▒▒▒▒▒▒░░░░░░░░░░░░░░░',
  '▒▒▒▒▒▓▓▓▒▒▓▒▒▒▒▒▒▓▓▓▓▒▒▒▒░░░░░▒▒░▒▒▒▒▓▓▓▓▓▓▓▓▒▓▒▓▓▒▒▓▓▓▓▓▒▒▒░░░░░▒▒░░░░░░░░░░░░',
  '░░▓▓▓▓▓▓▓▓▓▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▒▒▓▓▓▒▒▓▒▒▒▒▒▒▒▒▒▒░░░░░░░░░░░░░░░',
  '░░▓▓▓▒▒▓▒░▓▒▒▒▓▓▓▒▒▒▒▒▒▒▒▓▒▒▓▒▒▒▒▒▒▒▒▒▓▓▓▒▒▒░░░░░░▒▒▓▓▒▒▒▒▒▒▒▒░░░░░░░░░░░░░░░░░',
  '░░▒▓▓▒▒▒░▒▒▒▒▒▒▒▒▒▒▒▒▒░▒▒▒░░░▒▒▓▒▒▒▒▒▒▓▓▓▓▒▒▒▒▒▒▒▒▒▒▓▓░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░▓▓▓▒▒░▒▒▒▒▓▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▒▒▒▒▒░░▒▒▒▒▒▒▒▓▒░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░▒▓▓▒░░▒▓▓▓▓▓▓▓▓▒▒▒░░▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒░▒▒▓▓▓░░░░░░▒▒▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░▓▓▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒░░░░▒▒▒▓▓▒░▒▓▓▓▒▒▓▓▓▓▒▒▒▒▒▒▒▒▒▒▓▒░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░▓█▓▒░▓▒▒▒▓▓▓▒▒▓▓█▓▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓█▓▒▒▒▒▒▒▒▒▓▒▒▓▓▒▒▒▒░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░▒▓▓▓▓▒▒▒▒▒▓▓▓▒▒▒▓▒▒▒▒▓▒▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▒░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓▒▓▓▓▓▓▒▓▓▓▓▓▓▓▒▓▓▒▒▒▓▓▓▓▒▒▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░▒█████████▓█████▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░▓███▓▓▓▓▓▓▓▓▓▓▓███████████▓▓▓▓▓▓▓▓▓▓▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░▓▓███▓▓▓▓▓▓▓▓▓▓█████▒░██████▓▓▓▓▓▓▓▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░▒▓███▓▓▓▓▓▓▓████████░░░▓███▓██████▓▓▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░▒███████████████████▓░░▓████████████▓▓▓░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░▒▓▓██████████████████▒░░░▓████████████▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░▒████████████████████████▓░░░░░░░░▓████████████▓▒░░░░░░░░░░░░░░░░░░░░░░░░░',
  '░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒▓▓▓▓▓▓▓▓▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░',
].join('\n') + '\n';
